var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.992 2c7.732 0 14 6.268 14 14 0 7.654-6.143 13.874-13.768 13.998l-.232.002V18.2l-1.777 1.778-.227 4.435 1.853 5.58a13.9 13.9 0 0 1-3.18-.41l-.254-.064-.897-2.698-2.543 1.275a14.158 14.158 0 0 1-2.57-1.912l-.192-.184 4.708-2.36.137-2.698-2.699.138-2.358 4.708a14.006 14.006 0 0 1-1.96-2.532l-.137-.231 1.276-2.543-2.697-.896a14.023 14.023 0 0 1-.467-3.161L2 16.15l5.58 1.854 4.435-.226L13.793 16l-1.778-1.778-4.435-.226L2 15.849c.012-1.098.157-2.16.408-3.182l.065-.254 2.698-.896-1.275-2.543a14.094 14.094 0 0 1 1.912-2.57l.185-.193 2.36 4.708 2.698.138-.137-2.7L6.205 6a13.988 13.988 0 0 1 2.532-1.96l.23-.137 2.542 1.275.896-2.697a13.984 13.984 0 0 1 3.162-.466l.274-.006-1.854 5.579.227 4.435 1.778 1.778V2zm3.111 3.564v20.872c4.494-1.341 7.778-5.513 7.778-10.436.001-4.869-3.211-9.002-7.629-10.391l-.147-.046z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDfi);
export default __webpack_public_path__ + "static/media/DFI.375e6628c02c586b9af8cfa4a47ff03a.svg";
export { ForwardRef as ReactComponent };